<template>
  <div class="holder">
    <input type="text"
           class="form-control"
           v-model="inputValue"
           :disabled="disabled"
           :placeholder="placeholder"
           @keydown="keypress($event)"
           @input="$emit('filter', $refs.inputElement.value)"
           @blur="blur"
           ref="inputElement"/>
    <div v-if="!selectedSuggestion && inputValue && suggestionData.length > 0"
         v-on-clickaway="blur"
         class="typeahead bg-light border border-dark"
         :style="{top: inputFieldHeight}">
      <a v-for="(d, idx) in suggestionData"
         :key="key(d)"
         :ref="'dropdown_' + idx"
         class="dropdown-item"
         :class="{'bg-white': hoveredSuggestion === d}"
         href="#"
         @mouseover="hoveredSuggestion = d"
         @mousedown="selectOption(d, $refs['dropdown_' + idx].innerText)"
         tabindex="-1">
        <slot name="suggestion" :suggestion="d">{{ d }}</slot>
      </a>
    </div>
  </div>
</template>

<script>
import {mixin as clickaway} from 'vue-clickaway';

export default {
  props: {
    // value should have the same type like elements in suggestionData
    value: {
      required: true
    },
    initialDisplayValue: String,
    suggestionData: Array,
    disabled: Boolean,
    placeholder: String,
    keyAttribute: {
      type: String
    }
  },
  data() {
    return {
      inputValue: undefined,
      hoveredSuggestion: '',
      selectedSuggestion: undefined
    }
  },
  computed: {
    inputFieldHeight() {
      let inputElement = this.$refs.inputElement;
      return new Number(inputElement.offsetTop + inputElement.offsetHeight) + 'px';
    }
  },
  methods: {
    key(suggestionData) {
      return this.keyAttribute ? suggestionData[this.keyAttribute] : suggestionData
    },
    keypress(event) {
      let charCode = event.keyCode || event.which;
      if (charCode == 13) { // enter
        if (this.hoveredSuggestion)
          this.selectOption(this.hoveredSuggestion)
      } else if (charCode == 40) { // arrow-down
        let idx = this.suggestionData.indexOf(this.hoveredSuggestion);
        this.hoveredSuggestion = this.suggestionData[Math.min(idx + 1, this.suggestionData.length - 1)];
      } else if (charCode == 38) { // arrow-up
        let idx = this.suggestionData.indexOf(this.hoveredSuggestion);
        this.hoveredSuggestion = this.suggestionData[Math.max(idx - 1, 0)];
      } else if (charCode == 27) { // escape
        this.blur() // closes the suggestion canvas
      } else if (charCode != 9) { // not tab
        this.selectedSuggestion = undefined
      }
    },
    selectOption(d, text) {
      if (!text) {
        let idx = this.suggestionData.indexOf(d)
        text = this.$refs['dropdown_' + idx][0].innerText
      }
      this.inputValue = text
      this.selectedSuggestion = d
      this.hoveredSuggestion = undefined
      this.$emit('filter', '')
      this.$emit('input', this.selectedSuggestion)
    },
    blur() {
      if (!this.selectedSuggestion)
        this.inputValue = ''
    }
  },
  watch:{
    value() {
      if(!this.value)
        this.inputValue = ''
    }
  },
  mounted() {
    if (this.value)
      this.selectOption(this.value, this.initialDisplayValue)
  },
  mixins: [clickaway]
}
</script>

<style>
.holder {
  position: relative;
}

.typeahead {
  position: absolute;
  left: 1rem;
  z-index: 50;
}
</style>
